<div class="feed-widget-insights" *ngIf="subscriptionToInsights">
  <ng-container>
    <div
      class="call-to-action"
      [ngClass]="{
        'no-search-field': !isSearchFieldLoading && !searchFields.length && !searchTerm && !linkedSearchField
      }"
    >
      <div
        class="search-field-selector"
        [class.has-search-term]="!!searchTerm || selectedSearchField"
        *ngIf="isSearchFieldLoading || searchFields.length || !!searchTerm"
      >
        <ui-loader *ngIf="isSearchFieldLoading" class="loader-ng-select"></ui-loader>
        <ng-select
          class="ui2-dropdown mr-3"
          dropdownPosition="bottom"
          [typeahead]="typeAheadSub"
          [disabled]="disableSearchFieldPicker"
          [(ngModel)]="selectedSearchField"
          [placeholder]="'newsFeedWidget.header.placeholderSelector' | translate"
          (clear)="updateSearchField(null)"
          (change)="updateSearchField($event)"
          bindLabel="title"
          [items]="searchFields"
          (scrollToEnd)="scrollToEnd()"
        >
          <ng-template ng-option-tmp let-item="item" let-index="index">
            <div class="option-template">
              <div class="search-field-label">{{ item.title }}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
  </ng-container>
</div>
